import ReactDOM from 'react-dom/client';
import './index.css';
import 'animate.css';
import GJobPost from './gjobhub/jobs/GJobPost';
import GUploadResume from './gjobhub/jobs/GUploadResume';
import Navigation from './gjobhub/data/Navigation.json';
import GJobContactUs from './gjobhub/Js/GJobContactUs';
import GJobsIndex from './gjobhub/Js/GJobsIndex';
import CheckResume from './gjobhub/jobs/CheckResume';
import TADashBoard from './gjobhub/jobs/TADashBoard';
import GCandidatesgrid from './gjobhub/Js/GCandidates-grid';
import GEmployersSingle from './gjobhub/Js/GEmployersSingle';
import GJobAboutUs from './gjobhub/Js/GJobAboutUs';
import GJobSingle from './gjobhub/Js/GJobSingle';
import GCandidateSingle from './gjobhub/Js/GCandidateSingle';
import GJobsHubApp from './gjobhub/Js/GJobsHubApp.js';
import TalendDashBoard from './gjobhub/jobs/TADashBoard';
// import { useNavigate } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
let path = window.location.pathname;

    
   if(path.match(Navigation.NAVIGATE_URL_TADASHBOARD)){
        root.render(
        <TalendDashBoard />
        );
    } else {
    root.render(
        <GJobsHubApp/>
    );
    }
     

